import styled, { css } from 'styled-components'

import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import ReferralImage from '../../../../assets/img/referral-image.webp'
import UpdateProfileBackground from '../../../../assets/img/update-profile/update-profile-background.png'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

export const MainPage = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`

export const Header = styled.div`
position: relative;
display: flex;
flex: 0 0 auto;
flex-direction: row;
flex-wrap: wrap;
align-items: center;
min-height: 87px;
font-size: 0.7rem;
background: var(--color-primary);

&::before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: url('${MoreHeaderParticles}');
  background-repeat: no-repeat;
  background-position: right top;
}
`

export const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

export const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  ${({ hasExitButton }) => hasExitButton && 'margin-right: 60px;'}
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

export const Content = styled.div`
  flex: 1 1 auto;
  position: relative;
  padding: 2rem;
  overflow: auto;

  ${props =>
    props.withBackground &&
    css`
  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('${UpdateProfileBackground}');
    background-repeat: no-repeat;
    background-size:100%;
    max-height: 550px;
  }
`}
`

export const DetailPageContainer = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  background-color: inherit;
  transition-property: width;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-linear);
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
`

export const SubTitle = styled.h5`
  font-size: 1rem;
  margin: 0;
  margin-bottom: 0.2rem;
`

export const SubTitleCenter = styled(SubTitle)`
  text-align: center;
`

export const Description = styled.p`
  font-size: 0.875rem;
  line-height: 1.3125rem;
  letter-spacing: var(--letter-spacing-narrower);
  text-align: center;
  margin-top: 0;
`

export const FormWrapper = styled.div`
  margin-bottom: 2rem;
`

export const PermissionLabel = styled.div`
  text-align: center;
  font-size: 0.875rem;
  margin: 1rem 0;
`

export const DisplayImage = styled.img.attrs({ src: ReferralImage })`
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  display: block;
`

export const ConfirmTitle = styled.h2`
  color: var(--color-primary);
  text-align: center;
  font-size: 1.5rem;
  font-weight: var(--font-weight-bold);
`

export const BlockActionButton = styled(ActionButton)`
  margin-top: 2rem;
  width: 100%;
`

export const StyledLink = styled.a`
  cursor: pointer;
  display: block;
  text-transform: uppercase;
  color: var(--color-primary);
  margin-top: 1rem;
  text-align: center;
`
